<template>
  <div class="content-container">
    <search-comp
      :search-show="true"
      @onSearch="attachData(searchParams)"
      @onReset="onReset"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tên đồ vật</div>
                <input v-model="searchParams.name" type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Vị trí</div>
                <input v-model="searchParams.location" type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <el-select
                  v-model="searchParams.subBookingGroupId"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, index) in bookingGroupOptions"
                    :key="index"
                    :value="item.sub_booking_group_id"
                    :label="item.recode"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày thất lạc</div>
                <MultiCalendar
                  :from-date="searchParams.dateFrom"
                  :to-date="searchParams.dateTo"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày trả lại</div>
                <MultiCalendar />
              </div>
            </div> -->
          </div>
          <!-- <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Người tìm thấy</div>
                <input type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Người trả lại</div>
                <input type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <el-select
                  v-model="searchParams.subBookingGroupId"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, index) in bookingGroupOptions"
                    :key="index"
                    :value="item.sub_booking_group_id"
                    :label="item.recode"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @rowClicked="isRowSelected = true"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="!isRowSelected"
        class="btn primary small outline"
        @click="deleteRow"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="!isRowSelected"
        class="btn primary small outline"
        @click="editRow"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ $t('button.add') }}
      </button>
    </div>
    <!--  -->
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleLostAndFoundEdit')
          : $t('dialog.titleLostAndFoundAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="700px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Ngày tìm thấy">
                  <div class="das-form-input">
                    <div class="label required">Ngày tìm thấy</div>
                    <SingleCalendar
                      v-model="submitForm.date_found"
                      @input="onChangeDateFound($event)"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Nơi tìm thấy">
                  <div class="das-form-input">
                    <div class="label required">Nơi tìm thấy</div>
                    <input v-model="submitForm.location" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Đặt phòng">
                  <div class="das-form-input">
                    <div class="label required">Đặt phòng</div>
                    <el-select
                      v-model="submitForm.sub_booking_group_id"
                      placeholder=""
                    >
                      <el-option
                        v-for="(item, index) in bookingGroupOptions"
                        :key="index"
                        :value="item.sub_booking_group_id"
                        :label="item.recode"
                      ></el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Tên khách">
                  <div class="das-form-input">
                    <div class="label required">Tên khách</div>
                    <input v-model="submitForm.traveller_nm" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Tên đồ vật">
                  <div class="das-form-input">
                    <div class="label required">Tên đồ vật</div>
                    <input v-model="submitForm.item_nm" type="text" />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required"
                  name="Số điện thoại khách"
                >
                  <div class="das-form-input">
                    <div class="label required">Số điện thoại khách</div>
                    <input v-model="submitForm.phone_number" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <!-- <validation-provider rules="required" name="Ngày trả lại"> -->
                <div class="das-form-input">
                  <div class="label">Ngày trả lại</div>
                  <SingleCalendar
                    v-model="submitForm.return_date"
                    @input="onChangeDateReturn($event)"
                  />
                </div>
                <!-- </validation-provider> -->
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Người tìm thấy">
                  <div class="das-form-input">
                    <div class="label required">Người tìm thấy</div>
                    <el-select v-model="submitForm.finder_id" placeholder="">
                      <el-option
                        v-for="(user, index) in userOptions"
                        :key="index"
                        :value="user.account.id"
                        :label="user.account.username"
                      ></el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <!-- <validation-provider rules="required" name="Người trả lại"> -->
                <div class="das-form-input">
                  <div class="label">Người trả lại</div>
                  <el-select v-model="submitForm.returner_id" placeholder="">
                    <el-option
                      v-for="(user, index) in userOptions"
                      :key="index"
                      :value="user.account.id"
                      :label="user.account.username"
                    ></el-option>
                  </el-select>
                </div>
                <!-- </validation-provider> -->
              </div>
              <div class="das-form-col col-6">
                <!-- <validation-provider rules="required" name="Người xác nhận"> -->
                <div class="das-form-input">
                  <div class="label">Người xác nhận</div>
                  <el-select v-model="submitForm.confirmer_id" placeholder="">
                    <el-option
                      v-for="(user, index) in userOptions"
                      :key="index"
                      :value="user.account.id"
                      :label="user.account.username"
                    ></el-option>
                  </el-select>
                </div>
                <!-- </validation-provider> -->
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Trạng thái">
                  <div class="das-form-input">
                    <div class="label required">Trạng thái</div>
                    <input v-model="submitForm.status" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <!-- <validation-provider rules="required|max: 100" name="Mô tả"> -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.desc') }}</div>
                  <div class="child-w-80">
                    <textarea v-model="submitForm.note" rows="4" />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateRow">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addRow">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line
import {
  getUsers,
  addLostAndFound,
  getBookingGroups,
  getList,
  updateLostAndFound,
  deleteLostAndFound
} from '@/api/houseKeeper/lost-and-found'
export default {
  components: {},
  data() {
    return {
      isRowSelected: false,
      bookingGroupOptions: [],
      userOptions: [],
      loading: false,
      isEdit: false,
      dialogFormVisible: false,
      submitForm: {
        date_found: null,
        location: null,
        sub_booking_group_id: null,
        traveller_nm: null,
        item_nm: null,
        phone_number: null,
        note: null,
        status: null,
        return_date: null,
        finder_id: null,
        returner_id: null,
        confirmer_id: null
      },
      searchParams: {
        name: null,
        location: null,
        dateFrom: null,
        dateTo: null,
        returnDateFrom: null,
        returnDateTo: null,
        finder: null,
        returner: null,
        subBookingGroupId: null
      },
      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        // },
        {
          headerName: this.$t('grid.column.foundedDate'),
          field: 'date_found',
          valueGetter: params => {
            return this.$displayDate(params.data.date_found)
          },
          tooltipField: 'date_found',
          maxWidth: 150,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.foundedPosition'),
          field: 'location',
          tooltipField: 'location',
          width: 150
        },
        {
          headerName: this.$t('grid.column.reservation'),
          field: 'sub_booking_group_id',
          tooltipField: 'sub_booking_group_id',
          width: 100
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'traveller_nm',
          tooltipField: 'traveller_nm'
        },
        {
          headerName: this.$t('grid.column.objectName'),
          field: 'item_nm',
          tooltipField: 'item_nm'
        },
        {
          headerName: this.$t('grid.column.phoneNumber'),
          field: 'phone_number',
          tooltipField: 'phone_number'
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.$nullValueInObj(this.submitForm)
    }
  },
  async mounted() {
    await this.attachData()
    await this.getUserOptions()
    await this.getBookingGroupOptions()
  },
  methods: {
    onReset() {
      this.$nullValueInObj(this.searchParams)
      this.attachData()
    },
    async getBookingGroupOptions() {
      const data = await getBookingGroups()
      this.bookingGroupOptions = data.data || []
    },
    onChangeDateFound(e) {
      this.submitForm.date_found = e
    },
    onChangeDateReturn(e) {
      this.submitForm.return_date = e
    },
    async getUserOptions() {
      const data = await getUsers()
      this.userOptions = data.data || []
    },
    async addRow() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await addLostAndFound(this.submitForm)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowSelected = gridApi.getSelectedRows()[0]
      Object.assign(this.submitForm, rowSelected)
      this.isEdit = true
      this.dialogFormVisible = true
    },
    async updateRow() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await updateLostAndFound(this.submitForm)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`code.${message}`)
          })
        })
    },
    async deleteRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.$vxConfirm(this.$t('alert.deleteConfirm'), async () => {
        const data = {
          idList: row.map(item => item.id)
        }
        await deleteLostAndFound(data)
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: message
            })
          })
      })
    },
    async attachData() {
      const data = await getList(this.searchParams)
      this.rows = data.data || []
      this.isRowSelected = false
    },
    resetInfo() {
      this.isEdit = false
      // this.item = {
      //   p_code: 'MAINTENANCE_LOCATION',
      //   id: null,
      //   code: null,
      //   desc: null
      // }
    }
  }
}
</script>

<style lang="scss"></style>
